// IF VALID, return undefined
// ELSE, return error string to display
// http://redux-form.com/7.0.3/examples/fieldLevelValidation/

const US_ZIPCODE = /^\d{5}(?:[-\s]\d{4})?$/i;
const CA_POSTALCODE = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;

const required = (value) => {
  const trimmedVal = typeof value === 'string'
    ? value.trim()
    : value;
  if (!trimmedVal) {
    return 'Field Required';
  }
  return undefined;
};

const maxLength = max => value =>
  (value && value.length > max ? `Must be ${max} characters or less` : undefined);
const minValue = min => value =>
  (value && value < min ? `Must be at least ${min}` : undefined);

const number = value => (value && isNaN(Number(value)) ? 'Must be a number' : undefined);
const email = value =>
  (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
    'Invalid email address' : undefined);
const postalCode = value => (US_ZIPCODE.test(value) || CA_POSTALCODE.test(value)
  ? undefined
  : 'You must enter a valid US or Canadian postal code');

export default {
  required,
  number,
  email,
  maxLength,
  minValue,
  postalCode,
};



// WEBPACK FOOTER //
// ./src/components/Forms/validators.js